import { GenerateObservable } from './GenerateObservable';

export const generate = GenerateObservable.create;



// WEBPACK FOOTER //
// ../../src/observable/generate.ts